module.exports = __webpack_public_path__ + "img/Poissonnerie.e07995be.jpg";